import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { installBrowserProtections } from '../lib/browserProtection';
import { isPanelPath } from '../lib/adminDomain';

/**
 * Panel ayarlarını yalnızca oyuncu portalına uygular.
 *
 * Ayarlar yüklenmeden önce üç değer de açık kabul edilir; sunucuya erişim
 * sorunu kısıtları sessizce kaldırmamalıdır. Yönetim paneli ise geliştirici
 * araçlarına ve normal kopyalama davranışına her zaman erişebilir.
 */
const BrowserProtection = () => {
  const settings = useSettings();
  const { pathname } = useLocation();
  // Panel kilitliyken ana sitedeki /admin portalın 404 sayfasıdır; korumalar
  // orada da durur (bkz. lib/adminDomain.isPanelPath).
  const disabledForAdmin = isPanelPath(settings, pathname);
  const contextMenu = !disabledForAdmin
    && settings.portal_block_context_menu !== false;
  const textCopy = !disabledForAdmin
    && settings.portal_block_text_copy !== false;
  const devtools = !disabledForAdmin
    && settings.portal_block_devtools !== false;

  useEffect(() => installBrowserProtections({
    contextMenu,
    textCopy,
    devtools,
  }), [contextMenu, textCopy, devtools]);

  return null;
};

export default BrowserProtection;
